import {Presenter} from '../../../Support/with_presenter';
import {MeService} from '../../../Network/MeService';
import {loadingResponse, NetworkResult} from '../../../Network/NetworkResult';
import {Me} from '../../../Models/Me';
import {SnippetService} from '../../../Network/SnippetService';
import {FullSnippet} from '../../../Models/Snippet';

export class EditSnippetPresenter implements Presenter {
    public me: NetworkResult<Me> = loadingResponse();
    public submitting: boolean = false;
    public description: string;

    constructor(private snippet: FullSnippet, private meService: MeService, private snippetService: SnippetService) {
        this.description = snippet.description || '';
    }

    public async mount(): Promise<void> {
        this.me = await this.meService.get();
    }

    public unmount(): void {
        /* Noop */
    }

    public onDescriptionChange(description: string) {
        this.description = description;
    }

    public async onSubmit() {
        try {
            this.submitting = true;
            await this.snippetService.updateSnippet(this.snippet.id, this.description);
        } catch (e) {
            console.error(e);
        } finally {
            this.submitting = false;
        }
    }
}
